<template>
    <div class="account-settings" ref="accountSettingsOverflow">
      
        <div class="section-account section-account-information">
            <div class="title-section">
              <div class="left">
                <h2>{{ $t('dash.settings.account.title.main') }}</h2>
                <p>{{ $t('dash.settings.account.title.secondary') }}</p>
              </div>

              <div class="right">
                <div v-if="formInfoUserIsModified() || formInfoAccountIsModified() || languageIsModified()" class="btn-outline-primary" @click="cancel">{{ $t('dash.button.cancel') }}</div>
                <div class="btn-primary" @click="save">{{ $t('dash.button.save') }}</div>
              </div>
                
            </div>

            <div class="item picture">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.user_picture.title") }}</h5>
                </div>
                <form class="form">
                    <div class="containerPicture">
                        <img :src="dataImage ? dataImage : formInfoUser.avatar && formInfoUser.avatar !== 'null' ? formInfoUser.avatar : 'img/avatar.jpg'">
                        <p class="delete" @click="deletePicture">{{ $t("dash.button.delete")}}</p>
                        <label class="edit" for="fileInput" id="fileLabel">{{ $t("dash.button.modify") }}</label>
                    </div>
                    <div :class="{dragAndDrop:true, hoverFile:fileHover, loadingUploadPicture:loadingUploadPicture}">
                      <input type="file" name="fileUpload" id="fileInput" accept="image/png, image/jpeg, image/jpg" @change="handleAddFiles($event)" hidden>
                      <label for="fileInput" id="fileLabel" @dragover.prevent="handleOverrideDefault($event); handleFileHover()" @dragenter.prevent="handleOverrideDefault($event); handleFileHover()" @dragleave.prevent="handleOverrideDefault($event); handleFileHoverEnd()" @drop.prevent="handleOverrideDefault($event); handleFileHoverEnd(); handleAddFiles($event)">
                        <div class="content-default">
                          <i class="fa-solid fa-cloud-arrow-up"></i>
                          <p class="instruction"><span class="pink">{{ $t("dash.settings.account.user_picture.drag_and_drop.title_1") }}</span> {{ $t("dash.settings.account.user_picture.drag_and_drop.title_2") }} <span class="bold">{{ $t("dash.settings.account.user_picture.drag_and_drop.title_3") }} </span></p>
                          <p class="format">SVG, PNG, JPG or GIF<br>(max. 800x400px)</p>
                        </div>

                        <div class="content-hover-file">
                          <i class="fa-solid fa-plus"></i>
                        </div>

                        <div class="content-upload-file">
                          <p>{{ $t("dash.loading") }}...</p>
                        </div>
                      </label>
                    </div>
                  </form>
            </div>
           
            <div class="item name">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.name.title")}}</h5>
                </div>
                <div class="form">
                  <div class="input">
                    <i class="fa-regular fa-circle-user"></i>
                    <input :placeholder="$t('dash.settings.account.name.last_name.placeholder')" v-model="formInfoUser.lastname">
                  </div>

                  <div class="input">
                    <input :placeholder="$t('dash.settings.account.name.first_name.placeholder')" v-model="formInfoUser.firstname">
                  </div>
                </div>
            </div>

            <div class="item email">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.email.title") }}</h5>
                    <p>{{ $t("dash.settings.account.email.subtitle") }}</p>
                </div>
                <div class="form">
                  <div class="input">
                    <i class="fa-regular fa-at"></i>
                    <input :placeholder="$t('dash.settings.account.email.placeholder')" v-model="formInfoUser.email">
                  </div>

                
                </div>
            </div>

            <div class="item number">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.phone.title") }}</h5>
                </div>
                <div class="form">
                  <div class="input">
                    <i class="fa-regular fa-phone"></i>
                    <input :placeholder="$t('dash.settings.account.phone.placeholder')" v-model="formInfoUser.phone">
                  </div>

                
                </div>
            </div>

            <div class="item password">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.password.title") }}</h5>
                    <p v-if="errorPassword" class="error"><i class="fa-regular fa-circle-exclamation"></i>{{ $t(errorPassword) }}</p>
                    <p v-else-if="statePassword == 'login'">{{ $t("dash.settings.account.password.subtitle.start") }}.</p>
                    <p v-else>{{ $t("dash.settings.account.password.subtitle.validate") }}.</p>
                </div>
                <div class="form">
                  <div class="input">
                    <i class="fa-regular fa-key"></i>
                    <input v-if="statePassword == 'login'" type="password" placeholder="******" v-model="password.current">
                    <input v-else :placeholder="$t('dash.settings.account.password.placeholder')" v-model="password.new" autocomplete="new-password">
                  </div>
                  <div v-if="statePassword == 'login'" class="btn-secondary btn" @click="changePassword">{{ $t("dash.settings.account.password.change_password") }}</div>
                  <div v-else class="btn-secondary btn" @click="changePassword">{{ $t("dash.button.validate") }}</div>
                </div>
            </div>

            <account-mfa v-if="mfaEnabled"></account-mfa>

            <div class="item language">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.language.title") }}</h5>
                </div>
                <div class="form">
                  <div class="input">
                   
                    <img :src="'img/flag/'+language+'-flag-circle.jpg'">
                    <SelectComponent :changeValueSelect="changeLanguage" :data="{fr:'Français',en:'English',de:'Deutsch',es:'Español',pt:'Português', it:'Italiano'}" :valueSelect="language" :positionY="'top'"></SelectComponent>
                  </div>

                  
                </div>
            </div>

            <div class="item bitly-token" v-if="infoUser.admin">
                <div class="name">
                    <h5>{{ $t("dash.settings.account.bitly_token.title") }}</h5>
                    <p>{{ $t("dash.settings.account.bitly_token.subtitle") }}</p>
                </div>
                <div class="form">
                  <div class="input">  
                    <input :placeholder="$t('dash.settings.account.bitly_token.placeholder')" v-model="formInfoAccount.bitly_token">
                  </div>
                </div>
            </div>

            <div class="item onboarding" v-if="infoUser.admin">
              <div class="name">
                <h5>{{ $t("dash.settings.account.onboarding.title") }}</h5>
                <p>{{ $t("dash.settings.account.onboarding.subtitle") }}</p>
              </div>
              <div class="form">
                <div class="btn-secondary btn" style="margin-left: auto; width: 50%;" @click="restartOnboarding">{{ $t("dash.settings.account.onboarding.button") }}</div>
              </div>
            </div>

            <div class="item onboarding" v-if="!isProduction">
              <div class="name">
                <h5>{{ $t("dash.settings.account.guided_tour.title") }}</h5>
                <p>{{ $t("dash.settings.account.guided_tour.subtitle") }}</p>
              </div>
              <div class="form">
                <div class="btn-secondary btn" style="margin-left: auto; width: 50%;" @click="restartTour">{{ $t("dash.settings.account.guided_tour.button") }}</div>
              </div>
            </div>

            <div class="btns-action">  
              <div class="btn-data-account btn-secondary icon-l" @click="downloadData">
                <i class="fa-solid fa-download"></i>
                {{ $t('dash.settings.account.export_data') }}
              </div>

              <div class="btn-delete-account btn-primary icon-l" @click.stop="deleteAccountModal">
                <i class="fa-solid fa-trash-can"></i>
                {{ $t('dash.settings.account.remove_account') }}
              </div>
             </div>

        </div>
    </div>
</template>

<script>

import SelectComponent from './../utils/select.vue'
import AccountMfa from './account-mfa.vue'
import { mfaFeatureEnabled } from '@/utils/betaFeatures'

//mixins
import UserMixins from '../../mixins/User.vue'
import AuthMixins from '../../mixins/Auth.vue'
import SettingsMixins from '../../mixins/Settings.vue'
import { EventBus } from '@/event-bus';
import { clearOnboardingFlags } from '../../onboarding/utils/onboardingPersistence';

export default {
    name: 'account-settings',

    components : {
      SelectComponent,
      'account-mfa': AccountMfa
    },

    mixins: [UserMixins,AuthMixins,SettingsMixins],

    props : {
      infoUser : Object,
      infoAccount : Object,
      updateInfoUser : Function,
      updateInfoAccount : Function,
    },

    data() {
        return {
            language : 'fr', //a retirer
            formInfoUser : {},
            formInfoAccount : {},


            //For dropFile Picture
            fileHover : false,
            droppedFile : null,
            dataImage : null,
            loadingUploadPicture : false,

            //password
            statePassword : "login",
            password : {
              current : "",
              new : ""
            },
            errorPassword : null
        };
    },

    computed: {
      isProduction() {
        return process.env.NODE_ENV === 'production'
      },
      mfaEnabled() {
        return mfaFeatureEnabled()
      }
    },

    async mounted() {
      this.formInfoUser = {...this.infoUser};
      this.formInfoAccount = {...this.infoAccount};

      // a stale bug (fixed in User.vue) could have persisted the literal string "null", which
      // is truthy and so passes straight through both checks below unless excluded explicitly
      if (!localStorage.language || localStorage.language === 'null') localStorage.setItem('language', 'fr')
      this.language = (localStorage.language && localStorage.language !== 'null') ? localStorage.language : 'fr';

      EventBus.$on('handlerDeleteAccount', this.deleteAccount);

      const params = new URLSearchParams(location.search)
      const redirect_status = params.get('redirect_status')
      const setup_intent = params.get('setup_intent')
      const setup_intent_client_secret = params.get('setup_intent_client_secret')
      console.log('redirect_status :', redirect_status)
      console.log('setup_intent :', setup_intent)
      console.log('setup_intent_client_secret:', setup_intent_client_secret)

      // Paypal save PM
      if (redirect_status == 'succeeded' && setup_intent && setup_intent_client_secret) {
        
        const { VUE_APP_STRIPE_KEY, VUE_APP_API_HOST } = process.env
        let stripe = Stripe(VUE_APP_STRIPE_KEY) // eslint-disable-line
        const setupIntent = await stripe.retrieveSetupIntent(setup_intent_client_secret);
        console.log('paymentIntent retrievePaymentIntent', setupIntent)
        if (setupIntent && setupIntent.setupIntent && setupIntent.setupIntent.status === 'succeeded') {
          // Handle successful payment
          // Send new payment method to server (it will forward it to Stripe)
          const apiRoute = `${VUE_APP_API_HOST}/accounts/me/payment-method`
          const req = await this.$http.put(apiRoute, {
            pm: setupIntent.setupIntent.payment_method,
            type: 'paypal'
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })
  
          // Check pm was correctly saved
          if (!req.ok) {
            this.$vs.notify({
                title: this.$t('dash.notifications.error_title'),
                text : this.$t('dash.settings.payment_method.failure')
            });
            return
          }
  
          this.$vs.notify({
              title: this.$t('dash.settings.payment_method.changed.title'),
              text: this.$t('dash.settings.payment_method.changed.body'),
              color: '#b64985',
              icon: 'credit_card',
          })
  
          location.href = '/#/dash/settings/billing'
        }

      }
    },


    methods: {
      changeLanguage(value) {
        this.language = value
      },

      cancel(){
        this.formInfoUser = {...this.infoUser};
        this.formInfoAccount = {...this.infoAccount};
        this.language = localStorage.language;
      
      },

      async save(){
        
        if (this.languageIsModified()) {
          localStorage.setItem('language', this.language)
          location.reload()
          this.$i18n.locale = this.language
          this.saveLocale(this.infoUser.id, this.language)
          this.$forceUpdate();
        }
        

        if (this.formInfoUserIsModified()) {
          let bodyInfoUser = {
            firstname: this.formInfoUser.firstname || '',
            lastname: this.formInfoUser.lastname || '',
            email: this.formInfoUser.email.trim(),
            phone: !this.formInfoUser.phone || this.formInfoUser.phone == 'null' ? '' : this.formInfoUser.phone,
            id: this.infoUser.id,
          }
          const resultSaveInfoUser = await this.updateInfoUser(bodyInfoUser)
          if(!resultSaveInfoUser) {
            this.$vs.notify({
                  title: this.$t('dash.notifications.error_title'),
                  text: this.$t('dash.notifications.error_body'),
                  color:'success'
            })
            return;
          }
        }

        if (this.formInfoAccountIsModified()) {
          let bodyInfoAccount = {
            id: this.formInfoAccount.id,
            bitly_token: this.formInfoAccount.bitly_token,
          }
          const resultSaveInfoAccount = await this.updateInfoAccount(bodyInfoAccount)
          if(!resultSaveInfoAccount) {
            this.$vs.notify({
                  title: this.$t('dash.notifications.error_title'),
                  color:'error'
            })

            return
          }

        }

        EventBus.$emit("handlerRefreshUser") 
        this.$vs.notify({
            title: this.$t('dash.notifications.success_title'),
            text: this.$t('dash.notifications.user_updated'),
            color:'success'
        })

        
      
      },

      formInfoUserIsModified(){
        const propertys = ['lastname', 'firstname', 'phone', 'email']
        return propertys.some(propertys => this.formInfoUser[propertys] !== this.infoUser[propertys])
      },

      formInfoAccountIsModified(){
        const propertys = ['bitly_token']
        return propertys.some(propertys => this.formInfoAccount[propertys] !== this.infoAccount[propertys])
      },

      languageIsModified() {
        return this.language !== localStorage.language
      },

      async deletePicture() {

        let bodyInfoUser = {
          avatar: null,
          id: this.infoUser.id,
        }

        const resultSaveInfoUser = await this.updateInfoUser(bodyInfoUser)
        if(!resultSaveInfoUser) {
          alert('imposible de surpimer l\'image');
          return;
        }

        this.infoUser.avatar = null;
        this.droppedFile = null;
        this.dataImage = null;
      },

      async changePassword() {
        this.errorPassword = null;
        switch (this.statePassword) {
          case "login": {
            if(this.password.current !== "") {
              try {
                let data = {
                  password : this.password.current,
                  email : this.infoUser.email,
                }
                const res = await this.login(data);
                const { success } = res.body;

                if (success !== true || 'error' in res.body) {
                  this.errorPassword = "Le mot de passe est incorrect."
                  return
                }

                
                this.statePassword = 'newPassword'
              } catch (error) {
                return false;
              }
            }
            
            break
          }
          case "newPassword": {
              if(this.password.new == "" || (this.password.new).length < 8 ) {
                this.errorPassword = "Le mot de passe doit contenir au moins 8 caractères."
                return
              }
              if(!/[A-Z]/.test(this.password.new)) {
                this.errorPassword = "Le mot de passe doit contenir au moins 1 majuscule."
                return
              }
              if(!/\d/.test(this.password.new)) {
                this.errorPassword = "Le mot de passe doit contenir au moins 1 chiffre."
                return
              }
              let data = {
                oldpassword: this.password.current,
                newpassword: this.password.new
              }
              const res = await this.resetPassword(data);
              const { success } = res.body;

              if (success !== true || 'error' in res.body) {
                this.errorPassword = "Impossible de mettre à jour le mot de passe."
                return
              }else{
                alert('mot de passe a bien été changé')
              }

              this.password.current = '';
              this.password.new = '';
              this.statePassword = 'login';

                
            break
          }

        }
      },

      restartOnboarding() {
        clearOnboardingFlags()
        localStorage.removeItem('onboardingCompleted')
        localStorage.removeItem('onboardingSkipped')
        this.$store.commit('onboarding/RESET_ONBOARDING')
        this.$router.push('/onboarding/networks')
      },

      restartTour() {
        localStorage.removeItem('tours_completed')
        localStorage.removeItem('tour_active')
        this.$store.dispatch('tours/startTour', 'planner')
        this.$router.push({ name: 'posts2' })
      },

      //methods for dropFile
      handleOverrideDefault(e){
        e.preventDefault();
        e.stopPropagation();
      },
      
      handleFileHover(){
        if(this.loadingUploadPicture) return
        this.fileHover = true;
   
      },

      handleFileHoverEnd(){
        this.fileHover = false
      },

      async handleAddFiles(e){
        if(this.loadingUploadPicture) return
        let files = e.target.files || e.dataTransfer.files;
        this.droppedFile = files[0];

        let bodyInfoUser = {
          avatar: files[0],
          id: this.infoUser.id,
        }

        const resultSaveInfoUser = await this.updateInfoUser(bodyInfoUser)
        if(!resultSaveInfoUser && !resultSaveInfoUser.success) {
          alert('imposible d enregistrer')
          return;
        }
        this.addviewImage(files[0])
      },

      async addviewImage(file) {
          await this.functionReader(file).then((data) => {
            this.dataImage = data
          })
      },

      functionReader(file){
          var reader;
          return new Promise((resolve, reject) => {
              reader = new FileReader();
              reader.onload = function (e) {
                  resolve(e.target.result)
              }
              reader.readAsDataURL(file);
          })
      },

      deleteAccountModal() {
        if (this.infoUser.admin) {
          EventBus.$emit("showModal", this.$t('dash.modal.are_you_sur'), "En supprimant ce compte administrateur, les permissions seront transférées à l'utilisateur le plus ancien ajouté, en l'absence d'un autre administrateur trouvé.", this.$t('dash.confirm'), this.$t('dash.button.cancel'),  "handlerDeleteAccount");
        }else{
          EventBus.$emit("showModal", this.$t('dash.modal.are_you_sur'), "Êtes-vous sûr(e) de vouloir supprimer votre compte ? Cette action est irréversible.", this.$t('dash.confirm'), this.$t('dash.button.cancel'),  "handlerDeleteAccount");
        }
       
      },

      deleteAccount() {
          this.removeUser(this.infoUser.id).then(res => {
            const { success, deleted } = res.body
  
            if (success !== true || 'error' in res.body) {
              this.$vs.notify({
                  title: this.$t('dash.notifications.error_title'),
                  text: this.$t('dash.notifications.error_body'),
                  color:'success'
              })
            }
            if (deleted) {
              // Disconnect and go to home page
              localStorage.clear()
              this.$router.push({
                name: 'auth',
                params: {}
              })
            }
          }).catch(this.handleError) 
      },

      downloadData() {
        const rows = [
            ["Data name", "value"],
            ["User id", this.infoUser.id],
            ["Last name", this.infoUser.lastname],
            ["First name", this.infoUser.firstname],
            ["E-mail", this.infoUser.email],
            ["Phone", this.infoUser.phone],
            ["Avatar", this.infoUser.avatar],
            ['Status notification "Error"', this.infoUser.notifications.error],
            ['Status notification "Info"', this.infoUser.notifications.info],
            ['Status notification "Inbox"', this.infoUser.notifications.inbox],
            ['Status notification "Page"', this.infoUser.notifications.page],
            ['Status notification "Source"', this.infoUser.notifications.source],
            ["Created at", this.infoUser.created_at],
            ["Confirmed at", this.infoUser.confirmed_at],
            ["Is admin", this.infoUser.admin],
            ["Compagny", this.infoAccount.company],
            ["Adress compagny", this.infoAccount.address],
            ["City compagny", this.infoAccount.city],
            ["Country compagny", this.infoAccount.country],
            ["Zipcode compagny", this.infoAccount.zipcode],
        ];
        console.log(rows)

        let csvContent = "data:text/csv;charset=utf-8,";

        rows.forEach(function(rowArray) {
            rowArray[1] = `"${rowArray[1]}"`
            let row = rowArray.join(";");
            csvContent += row + "\r\n";
        });
        console.log(csvContent)

        var encodedUri = encodeURI(csvContent);
        window.open(encodedUri);
      }

    },

    watch : {
      infoUser() {
        this.formInfoUser = {...this.infoUser};
      },
      infoAccount() {
        this.formInfoAccount = {...this.infoAccount};
      },

    },

    beforeDestroy () {
        EventBus.$off('handlerDeleteAccount', this.deleteAccount)
    }
};
</script>

